import { createAction } from 'redux-act';

export const setLoading = createAction('propertyAvailability/SET_LOADING');
export const fetchPropertyAvailability = createAction('propertyAvailability/FETCH_PROPERTY_AVAILABILITY');
export const fetchPropertyAvailabilitySuccess = createAction('propertyAvailability/FETCH_PROPERTY_AVAILABILITY_SUCCESS');
export const fetchPropertyAvailabilityFailure = createAction('propertyAvailability/FETCH_PROPERTY_AVAILABILITY_FAILURE');
export const clearResults = createAction('propertyAvailability/CLEAR_RESULTS');
export const updateQuery = createAction('propertyAvailability/UPDATE_QUERY');
export const setFilters = createAction('propertyAvailability/SET_FILTERS');
export const clearFilters = createAction('propertyAvailability/CLEAR_FILTERS');
